export const BACK_SOON_BADGE_TEXT = 'Back Soon'
